/**
 * SafeIntersections enums + specialised geodata shapes.
 *
 * The generic shapes (`IFeature<P, M>`, etc.) live in
 * `#lib/types.ts` and are app-agnostic. This file provides the
 * SafeIntersections enums and re-exports narrowed aliases under the names the
 * rest of the SafeIntersections code uses.
 *
 * `ISafeIntersectionsSystemLayers` and `ISafeIntersectionsSummaryData` are
 * kept as strict local interfaces (rather than generic aliases) so the
 * per-module-per-layer typing inside consumers stays precise.
 */

import type { ILayerSource, IFeature as IGenericFeature } from '#lib/types.js';

export enum ESafeIntersectionsModule {
	Identify = 'Identify',
	Prioritize = 'Prioritize'
}

export enum EProduct {
	SafeIntersections = 'SafeIntersections'
}

export enum EIdentify {
	Identify = 'Identify'
}
export enum EPrioritize {
	Prioritize = 'Prioritize'
}

export type ISafeIntersectionsFeature = IGenericFeature<EProduct, ESafeIntersectionsModule>;

export interface ISafeIntersectionsSystemLayers {
	[ESafeIntersectionsModule.Identify]: {
		[EIdentify.Identify]: ILayerSource | null;
	};
	[ESafeIntersectionsModule.Prioritize]: {
		[EPrioritize.Prioritize]: ILayerSource | null;
	};
}

export interface ISafeIntersectionsSummaryData {
	location_label: string;
	[ESafeIntersectionsModule.Identify]: Record<string, string | number>[];
	[ESafeIntersectionsModule.Prioritize]: Record<string, string | number>[];
}
